export interface Document {
    id: string | null
    application_id: string | null
    application_payment_id?: string | null
    type: string | null
    storage_key: string | null
    url: string | null
    content_type: string | null
    size: string | null
    uploaded_at: string | null
    created_at: string | null
    updated_at: string | null
}

export class DocumentModel implements Document {
    id: string | null = null
    application_id: string | null = null
    application_payment_id?: string | null = null
    type: string | null = null
    storage_key: string | null = null
    url: string | null = null
    content_type: string | null = null
    size: string | null = null
    uploaded_at: string | null = null
    created_at: string | null = null
    updated_at: string | null = null

    constructor(data?: Partial<Document>) {
        Object.assign(this, data)
    }

    static fromJSON(json: any): DocumentModel {
        if (!json) return new DocumentModel()
        return new DocumentModel({
            id: json.id ?? null,
            application_id: json.application_id ?? null,
            application_payment_id: json.application_payment_id ?? null,
            type: json.type ?? null,
            storage_key: json.storage_key ?? null,
            url: json.url ?? null,
            content_type: json.content_type ?? null,
            size: json.size ?? null,
            uploaded_at: json.uploaded_at ?? null,
            created_at: json.created_at ?? null,
            updated_at: json.updated_at ?? null,
        })
    }

    toJSON(): Record<string, any> {
        return {
            id: this.id,
            application_id: this.application_id,
            application_payment_id: this.application_payment_id,
            type: this.type,
            storage_key: this.storage_key,
            url: this.url,
            content_type: this.content_type,
            size: this.size,
            uploaded_at: this.uploaded_at,
            created_at: this.created_at,
            updated_at: this.updated_at,
        }
    }
}
